import {
  Component,
  ChangeDetectionStrategy,
  Input,
  EventEmitter,
  Output,
} from '@angular/core';
import {
  UwReportsViewModel,
  UwReportsViewReport,
} from './uw-reports-view-model';
import { ProductType } from '@core/models/api/dsm-types';
import { ProductsService } from '@core/services/products.service';
import { ModalService } from '@shared/services/modal.service';
import { UserModel } from '@entities/user/user.model';

@Component({
  selector: 'nwx-uw-reports-card',
  templateUrl: './uw-reports-card.component.html',
  styleUrls: ['./uw-reports-card.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class UwReportsCardComponent {
  @Input() model!: UwReportsViewModel;

  @Output() clickReportLink = new EventEmitter<UwReportsViewReport>();
  @Output() refresh = new EventEmitter<void>();

  constructor(
    private productsService: ProductsService,
    private modalService: ModalService
  ) {}

  onClickReportLink(report: UwReportsViewReport, event: MouseEvent): void {
    event?.preventDefault?.();
    this.clickReportLink.emit(report);
  }

  hasDisabled(model: UwReportsViewModel): boolean {
    return (
      model.uwIssues?.products?.some((item) =>
        item.issueDetails?.some((issue) => issue.includes('Critical Block'))
      ) ?? false
    );
  }

  onRequestUwApproval(productType: ProductType, user: UserModel): void {
    this.modalService.uwReferralModal(productType, user);
  }

  onRemoveProduct(productType: ProductType): void {
    this.productsService.selectProduct(productType, false);
  }

  refreshReports(): void {
    this.refresh.emit();
  }
}
